import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchEventsPathByLocale = {
  en: '/en/events',
  es: '/es/eventos',
} satisfies Record<I18nLocale, string>;

export const searchEventsPaths = Object.values(searchEventsPathByLocale);

export const searchEventsPathsWithoutLang = Array.from(
  new Set(searchEventsPaths.map((path) => path.substring(3))),
);
